import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full px-4 lg:px-8 md:flex gap-12 items-center text-left flex flex-col lg:flex-row lg:justify-center',
);

export const Title = w.h1(
  'text-4xl md:text-5xl xl:text-7xl text-[var(--azul-escuro)]'
);

export const SubText = w.p(
  'text-xl md:text-2xl xl:text-4xl mt-4 text-[var(--azul-escuro)]'
);

export const Text = w.ol(
  'text-xl lg:text-2xl mt-10 md:mt-12 list-decimal list-inside marker:font-bold'
);

export const Image = w.img(
  'w-full md:h-[280px] md:min-h-[280px] md:w-[340px] md:min-w-[340px] lg:h-[440px] lg:min-h-[440px] lg:w-[500px] lg:min-w-[500px]'
);
